export const debug = (title: string, msg: string, ...params: unknown[]) => {
	console.debug(`[${title}] ${msg}`, ...params);
};

export const info = (title: string, msg: string, ...params: unknown[]) => {
	console.info(`[${title}] ${msg}`, ...params);
};

export const warn = (title: string, msg: string, ...params: unknown[]) => {
	console.warn(`[${title}] ${msg}`, ...params);
};

export const error = (title: string, msg: string, ...params: unknown[]) => {
	console.error(`[${title}] ${msg}`, ...params);
};
